<template>
  <div class="ja-action-mix">
    <div class="ja-action-mix__header">
      <h3 class="ja-action-mix__title">Action Mix</h3>
      <p class="ja-action-mix__subtitle">Share of customer actions</p>
    </div>
    <div class="ja-action-mix__chart-wrap">
      <ja-apex-chart
        type="donut"
        :height="300"
        :options="chartOptions"
        :series="series"
      />
      <div class="ja-action-mix__center">
        <span class="ja-action-mix__center-label">Total actions</span>
        <span class="ja-action-mix__center-value">{{ totalActions.toLocaleString() }}</span>
      </div>
    </div>
    <div class="ja-action-mix__legend">
      <div
        v-for="item in actions"
        :key="item.name"
        class="ja-action-mix__legend-item"
      >
        <span class="ja-action-mix__dot" :style="{ background: item.color }" />
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import JaApexChart from "./JaApexChart.vue";

export default {
  name: "ActionMixChart",
  components: { JaApexChart },
  props: {
    actions: { type: Array, required: true },
    totalActions: { type: Number, default: 0 },
  },
  computed: {
    series() {
      return this.actions.map((a) => a.value);
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
        },
        labels: this.actions.map((a) => a.name),
        colors: this.actions.map((a) => a.color),
        plotOptions: {
          pie: {
            donut: {
              size: "72%",
              labels: { show: false },
            },
          },
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        stroke: { width: 2, colors: ["#fff"] },
        tooltip: {
          y: { formatter: (val) => val.toLocaleString() },
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.ja-action-mix {
  background: #fff;
  border-radius: 18px;
  padding: 1.35rem 1.5rem 1.25rem;
  box-shadow: 0 1px 2px 0 rgba(20, 21, 34, 0.04);
  border: 1px solid #ececf2;
  height: 100%;
  display: flex;
  flex-direction: column;

  &__header {
    margin-bottom: 0.25rem;
  }

  &__title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #2d2d2d;
    margin: 0 0 0.3rem;
    line-height: 1.3;
  }

  &__subtitle {
    font-size: 0.8125rem;
    color: #a8a8b3;
    margin: 0;
    line-height: 1.4;
  }

  &__chart-wrap {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 300px;
  }

  &__center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    pointer-events: none;
  }

  &__center-label {
    display: block;
    font-size: 0.75rem;
    color: #a8a8b3;
    line-height: 1.3;
    margin-bottom: 0.15rem;
  }

  &__center-value {
    display: block;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 1.5rem;
    font-weight: 800;
    color: #16172b;
    line-height: 1;
    letter-spacing: -0.4px;
  }

  &__legend {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 1.25rem;
    margin-top: 0.75rem;
    padding-top: 0.25rem;
  }

  &__legend-item {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    font-size: 0.8125rem;
    font-weight: 500;
    color: #6b7280;
    line-height: 1;
  }

  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 3px;
    flex-shrink: 0;
  }
}
</style>
